// extracted by mini-css-extract-plugin
export default {"struck":"vOOYUN","infoIcon":"HhUpLb","introOffer":"AclOUA"};